export { SeriesLabelComponent, registerSeriesLabel } from './series-label';
export * from './type';
export { getSeriesLabelConfig, appendSeriesLabelConfig } from './util';
